import RunStateBadge from "components/Run/elements/StateBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableChildRow } from "../types";

const ModulePullRequestsTableRunStatusCell = ({
  item: { run },
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableChildRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <RunStateBadge state={run.state} />
    </TableSimpleCell>
  );
};

export default ModulePullRequestsTableRunStatusCell;
